import { useLocalStorage } from '@vueuse/core'

const logHistory = useLocalStorage<string[]>('log-history', [])

const originalLog = console.error
export function handleLogHistory() {
  console.error = function (...args) {
    // Only keep the last 30 logs
    const datetime = new Date().toISOString()
    logHistory.value.push(
      `${datetime} ${JSON.stringify(args, (_, value) =>
        typeof value === 'bigint' ? value.toString() : value,
      )}`,
    )
    logHistory.value = logHistory.value.slice(-30)

    originalLog.apply(console, args)
  }
}
